// Markers

/**
 * Marks the start of the CLI entry point.
 */
export const PerfMarkerCliEntry = 'CLI_ENTRY';

// Measurements

/**
 * Measures the time it takes to open the browser.
 */
export const PerfMeasurementOpenBrowser = 'OPEN_BROWSER';
